import React from 'react';
import { AppIcon, AppBlur } from 'AdminApp/components';

export default class AppWidget extends React.Component {

  render() {
    let bodyClasess = ['box-body'];
    if(this.props.padded) {
      bodyClasess.push('padded');
    }
    return (
      <div className="box" {...this.props}>
        <div className="box-header"><h3 className="box-title"><AppIcon icon={this.props.icon}/> {this.props.title}</h3></div>
        <AppBlur>
          <div className={bodyClasess.join(' ')}>
            {this.props.children}
          </div>
        </AppBlur>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/widgets/AppWidget.js